import { action, makeObservable, observable, reaction } from 'mobx';

import { baseAgent } from 'src/api/agent';

import type { PluginInstanceController, PluginObject } from './types';
import type { IDirectoryPageCurrentDirectory } from 'src/pages/directory/directory-page-service';
import type { MainDirectoryService } from 'src/services/directory-service/main-directory-service';
import type { NotificationsService } from 'src/services/notifications-service';

import { PluginsRecord } from './plugins-record';
import { DirectoriesNames, PluginName } from './types';

export class PluginsService {
  @observable plugins: PluginObject<PluginName, PluginInstanceController[PluginName]>[] = [];

  constructor(
    private readonly directoryPageService: IDirectoryPageCurrentDirectory,
    private readonly notificationsService: NotificationsService,
  ) {
    makeObservable(this);
  }

  @action.bound
  setPlugins(currentDirectory: MainDirectoryService) {
    switch (currentDirectory.directoryName) {
      case DirectoriesNames.GOdashboard_Log:
        this.plugins = [
          {
            ...PluginsRecord[PluginName.RefreshLogs],
            pluginController: new PluginsRecord[PluginName.RefreshLogs].pluginController(
              baseAgent,
              this.notificationsService,
              this.directoryPageService,
            ),
          },
        ];
        break;

      case DirectoriesNames.Common_Well:
        this.plugins = [
          {
            ...PluginsRecord[PluginName.SyncWithDb],
            pluginController: new PluginsRecord[PluginName.SyncWithDb].pluginController(
              baseAgent,
              this.notificationsService,
              this.directoryPageService,
            ),
          },
        ];
        break;

      default:
        this.plugins = [];
        break;
    }
  }

  init = () => {
    const setPluginsDisposer = reaction(
      () => this.directoryPageService.currentDirectory,
      () => {
        if (this.directoryPageService.currentDirectory) {
          this.setPlugins(this.directoryPageService.currentDirectory);
        } else {
          // Тут нужно будет диспозить плагины
          return;
        }
      },
      { fireImmediately: true, name: 'pluginsSetter' },
    );

    return () => {
      setPluginsDisposer();
    };
  };
}
